<template>
  <div class="list-locale">
    <div class="menu-item flex-center">
      <div class="custom-dropdown locale-dropdown-menu flex-center">
        <a
          class="custom-dropdown-toggle icon-item"
          @click="showListLocale = !showListLocale"
          :class="{ active: showListLocale }"
        >
          <span v-if="lang.locale === 'pt'">
            <img
              src="/img/languages/br.png"
              alt=""
              class="img-icon"
              :class="lang.locale"
            /><icon :name="'bottom-arrow'"></icon>
          </span>
          <span v-if="lang.locale === 'en'">
            <img
              src="/img/languages/en-us.png"
              alt=""
              class="img-icon"
              :class="lang.locale"
            /><icon :name="'bottom-arrow'"></icon>
          </span>
          <span v-if="lang.locale === 'es'">
            <img
              src="/img/languages/es.png"
              alt=""
              class="img-icon"
              :class="lang.locale"
            /><icon :name="'bottom-arrow'"></icon>
          </span>
        </a>
        <div
          class="custom-dropdown-menu locale-dropdown"
          :class="{ show: showListLocale }"
        >
          <a
            v-for="(locale, index) in locales"
            :key="`list-locale-${index}`"
            class="dropdown-item"
            @click="changeLanguage(locale.value)"
          >
            <img :src="locale.image" alt="" class="img-icon" />
            <span>{{ locale.text }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: { Icon: () => import('@/components/Shared/Icon') },
  props: {
    heading: String,
    select: {
      Type: String,
      default: 'en',
    },
  },
  data() {
    return {
      lang: lang,
      locales: [
        {
          text: 'English',
          value: 'en',
          image: '/img/languages/en-us.png',
        },
        {
          text: 'Português',
          value: 'pt',
          image: '/img/languages/br.png',
        },
        {
          text: 'Español',
          value: 'es',
          image: '/img/languages/es.png',
        },

      ],
      showListLocale: false,
    }
  },

  methods: {
    changeLanguage(language) {
      this.showListLocale = false
      window.lang.setLocale(language)
      this.$cookies.set('lang', language, { expires: '30d' })

      this.$emit('language-changed', language);
    },
  },
}
</script>

<style lang="scss" scoped>
.list-locale {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 999;
  .custom-dropdown {
    height: 30px !important;
    width: 50px !important;
    justify-content: end !important;
    padding: 4px;
    border: 1px solid #ccc;
    border-radius: 4px;
    /*a {
      margin-left: 10px;
    }*/
    .custom-dropdown-toggle {
      span {
        display: flex;
      }
      svg {
        padding-left: 1px;
        padding-top: 6px;
      }
      img {
        height: 20px;
        width: 30px;
      }
    }
  }

  .locale-dropdown-menu {
    height: 40px;
    width: 40px;
  }
  .menu-item {
    display: inline-block;
    .icon-item {
      padding: 0;
      color: rgba(255, 255, 255, 0.6);
      min-width: 40px;
      width: 100%;
      display: block;
      line-height: 40px;
      max-height: 40px;
      text-align: center;
      cursor: pointer;
      &:hover,
      &.active {
        .v-icon {
          color: #5369f8;
        }
      }
    }
  }
}
</style>
